import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 13 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.025 9.551 7.585 1.84a1.257 1.257 0 0 0-2.17 0L.976 9.551a1.2 1.2 0 0 0 0 1.205 1.24 1.24 0 0 0 1.084.619h8.882a1.236 1.236 0 0 0 1.247-1.221c0-.212-.056-.42-.163-.603m-5.931-4.27a.406.406 0 0 1 .812 0v2.032a.406.406 0 1 1-.812 0zM6.5 9.75a.61.61 0 1 1 0-1.219.61.61 0 0 1 0 1.219"
    }, null, -1)
  ]))]))
}
export default { render: render }